<template>
  <div class="">
    <img :src="png1">
  </div>
</template>
<script>
const png1 = require('./scan.png')
export default {
  name: 'WeHeaderView',
  data() {
    return { png1 }
  }
}
</script>
